import React from "react";
import "./Styles.css";
import Prism from "prismjs";

// The code for App.js
const code = `
import React from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import HashRouting from "./components/HashRouting";
import RelativePaths from "./components/RelativePaths";
import Deploy from "./components/Deploy";
import ViewCode from "./components/ViewCode";
import "./components/Styles.css";

const App = () => {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/hash-routing">Hash Routing</Link>
            </li>
            <li>
              <Link to="/relative-paths">Relative Paths</Link>
            </li>
            <li>
              <Link to="/deploy">Deploy</Link>
            </li>
            <li>
              <Link to="/view-code">View Code</Link>
            </li>
          </ul>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/hash-routing" element={<HashRouting />} />
          <Route path="/relative-paths" element={<RelativePaths />} />
          <Route path="/deploy" element={<Deploy />} />
          <Route path="/view-code" element={<ViewCode />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;

`;
const About = "About";

const ViewCode = () => {
  Prism.highlightAll();

  return (
    <div className="content">
      <h1>View the Code</h1>
      <p>
        This page displays the code for the <code>App.js</code> file, which is
        the entry point for our React app. Here, we set up the router and define
        the routes for our app.
      </p>
      <pre>
        <code className="code">{code}</code>
      </pre>
      <h2>Explaining the Code</h2>
      <p>
        The <code>App.js</code> file sets up a <code>HashRouter</code> from the{" "}
        <code>react-router-dom</code> library. This automatically handles all
        the heavy lifting when it comes to hash routing. With the hash router
        imported as `Router`, you wont even need to change the syntax of your
        normal dApps much to accomodate.
      </p>
      <p>
        The <code>Route</code> components specify which component to render for
        each possible URL. For example, the{" "}
        <code>&lt;Route path="/about" element={About} /&gt;</code> line means
        that the <code>About</code> component is rendered when the URL's hash is{" "}
        <code>#/about</code>.
      </p>
      <p>
        The <code>Link</code> components in the navigation section create links
        to each of the routes. For example, the{" "}
        <code>&lt;Link to="/about"&gt;About&lt;/Link&gt;</code> line creates a
        link to the <code>#/about</code> URL, which displays the{" "}
        <code>About</code> page.
      </p>
    </div>
  );
};

export default ViewCode;
